import { XIcon } from 'lucide-react';
import { abbreviateNumber } from '../utils/formatNumbers';
import { getCurrencySymbol } from '../shared/currency';
import { Talent } from '../shared/types';
import { Button } from '@/components/ui/button';
import { LogoIcon } from './LogoIcon';

interface TalentMiniProps {
    tal: Talent,
    currency: string,
    handleRemove: (id: string) => void,
    price?: number,
}

function TalentMini(props: TalentMiniProps) {
    const { tal, currency, handleRemove, price = 0 } = props;
    const pd = tal.platformData;
    const displayHandle = pd?.TikTok?.username || pd?.Instagram?.username;

    return (
        // Row: avatar + meta vs remove control
        <div className="mb-4 flex justify-between">
            <div className="flex items-center">
                <div
                    className="mr-4 size-12 shrink-0 rounded bg-cover bg-center bg-no-repeat"
                    style={{ backgroundImage: `url(${tal.imgUrl ? tal.imgUrl : 'talent-default.png'})` }}
                />
                <div className="space-y-1">
                    <div><strong>@{displayHandle}</strong> - {getCurrencySymbol(currency)}{price.toLocaleString()}</div>
                    {/* Platform follower counts in a row */}
                    <div className="flex flex-wrap">
                        {pd?.TikTok?.followers != null ? (
                            <div className="mr-6 flex items-center">
                                <LogoIcon brand="TikTok" className="mr-2 size-5" />
                                <div>{abbreviateNumber(pd.TikTok.followers)}</div>
                            </div>
                        ) : null}

                        {pd?.Instagram?.followers != null ? (
                            <div className="flex items-center">
                                <LogoIcon brand="Instagram" className="mr-2 size-5" />
                                {abbreviateNumber(pd.Instagram.followers)}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="ml-1">
                <Button type="button" size="icon-sm" variant="ghost" onClick={() => handleRemove(tal.id)} aria-label="remove">
                    <XIcon />
                </Button>
            </div>
        </div>
    );
}

export default TalentMini;
